import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { fetchFactors } from '../services';
import { useAuthStore } from '@modules/auth/store';
import { MY_ACCOUNT_PHONE_NUMBER } from '../constants/api';
import { Factor } from '../types';
import { useAuth } from '@modules/auth/hooks';

const useQueryFactors = <TError = unknown>(
  options?: Omit<
  UseQueryOptions<Factor[] | undefined, TError, Factor[], string[]>,
  'initialData' | 'queryFn' | 'queryKey'
  >,
): UseQueryResult<Factor[]> => {
  const { isAuthenticated } = useAuth();
  const { user: currentUser } = useAuthStore();

  const enabledOption = options?.enabled !== undefined ? !!options?.enabled : true;

  return useQuery([MY_ACCOUNT_PHONE_NUMBER], async () => await fetchFactors(currentUser?.id ?? ''), {
    ...options,
    enabled: isAuthenticated === true && enabledOption,
  });
};

export default useQueryFactors;
